const initActions = (services) => {
    const axiosCall = services.axios.Axios();

    const triggerPathwayCodeSync = (practiceId) => {
        return async () => {
            try {
                await axiosCall.post(
                    `/partnerActions/pathway/codesync/${practiceId}`,
                    {}
                );
            } catch (error) {
                console.error(error.message);
            }
        };
    };

    return {
        triggerPathwayCodeSync,
    };
};

export default initActions;
